module.exports = __webpack_public_path__ + "static/media/surfEquipment.48607704.svg";